import Client from '../HttpClient';

const baseUrl = `/gateway/wombat-mgt/api/vs/manage-cardIssue`;

const list = (merchantId, assignBranchId, filters, page, pageSize) => {
	return Client.get(`${baseUrl}/${merchantId}/cardIssues/settleList`, {
		assignBranchId,
		...filters,
		page,
		pageSize,
	});
};

const listSold = (merchantId, branchId, filters, page, pageSize) => {
	return Client.get(`${baseUrl}/${merchantId}/giftCard/list`, {
		branchId,
		...filters,
		page,
		pageSize,
	});
};

const listByGroup = (
	merchantId,
	cardIssueApplyId,
	page,
	pageSize,
	cardCode,
	state
) => {
	return Client.get(`${baseUrl}/${merchantId}/cardIssues/page`, {
		cardIssueApplyId,
		cardCode,
		state,
		page,
		pageSize,
	});
};

const find = (merchantId, id) => {
	return Client.get(`${baseUrl}/${merchantId}/cardIssues/${id}`);
};

const detail = (merchantId, id) => {
	return Client.get(`${baseUrl}/${merchantId}/giftCardDetail/${id}`);
};

const download = (merchantId, cardIssueApplyId) => {
	return Client.post(
		`${baseUrl}/${merchantId}/cardIssues/download`,
		{},
		{
			cardIssueApplyId,
		},
		{
			responseType: 'blob',
		}
	);
};

const generate = (merchantId, cardIssueApplyId, operateBy) => {
	return Client.post(`${baseUrl}/${merchantId}/cardIssues/generate`, {
		cardIssueApplyId,
		operateBy,
	});
};

const allowDepositStatus = (merchantId) => {
	return Client.get(`${baseUrl}/${merchantId}/card-cardIssues/deposit-switch`);
};

const switchAllowDepositStatus = (merchantId, val, operateBy) => {
	return Client.post(
		`${baseUrl}/${merchantId}/card-cardIssues/deposit-switch`,
		{
			operateBy,
			val,
		}
	);
};

const transactions = (merchantId, branchId, filters, page, pageSize) => {
	return Client.get(`${baseUrl}/${merchantId}/card-transactions`, {
		branchId,
		...filters,
		page,
		pageSize,
	});
};

const modifySalesPrice = (
	merchantId,
	cardIssueApplyId,
	salesPrice,
	operatedBy
) => {
	return Client.put(`${baseUrl}/${merchantId}/sales-price/batch-modify`, {
		cardIssueApplyId,
		salesPrice,
		operatedBy,
	});
};

const refund = (merchantId, id, reason) => {
	return Client.post(`${baseUrl}/${merchantId}/eGiftCard/refund/${id}`, {
		reason,
	});
};

const resend = (merchantId, id) => {
	return Client.post(`${baseUrl}/${merchantId}/eGiftCard/sendMail`, {}, { id });
};

const downloadTransactions = ({
	branchId,
	cardCode,
	endTime,
	event,
	merchantId,
	startTime,
	timeZone,
}) => {
	let url = `${baseUrl}/${merchantId}/download/transactions?timeZone=${timeZone}`;
	if (endTime && startTime) {
		url += `&endTime=${endTime}&startTime=${startTime}`;
	}
	if (event) {
		url += `&event=${event || ''}`;
	}
	if (branchId) {
		url += `&branchId=${branchId}`;
	}
	if (cardCode) {
		url += `&cardCode=${cardCode}`;
	}
	return Client.get(
		url,
		{},
		{
			responseType: 'blob',
		}
	);
};

const downloadGiftCards = ({
	cardID,
	cardType,
	endTime,
	merchantId,
	startTime,
	status,
	timeZone,
	branchId,
}) => {
	let url = `${baseUrl}/${merchantId}/download/giftCards?timeZone=${timeZone}`;
	if (endTime && startTime) {
		url += `&endTime=${endTime}&startTime=${startTime}`;
	}
	if (branchId) {
		url += `&branchId=${branchId}`;
	}
	if (cardType) {
		url += `&cardType=${cardType}`;
	}
	if (status) {
		url += `&status=${status}`;
	}
	if (cardID) {
		url += `&cardID=${cardID}`;
	}
	return Client.get(
		url,
		{},
		{
			responseType: 'blob',
		}
	);
};

const downloadSettleList = ({ assignBranchId, merchantId }) => {
	const url = `${baseUrl}/${merchantId}/download/settleList`;
	return Client.get(
		url,
		{ assignBranchId, merchantId },
		{
			responseType: 'blob',
		}
	);
};

const batchActivate = (
	merchantId,
	branchId,
	applyId,
	validDate,
	expireDate
) => {
	return Client.post(`${baseUrl}/${merchantId}/activation/batch`, {
		branchId,
		applyId,
		validDate,
		expireDate,
	});
};

const batchActivateByCodes = (
	merchantId,
	branchId,
	cards,
	validDate,
	expireDate
) => {
	return Client.post(`${baseUrl}/${merchantId}/activation/batch/codes`, {
		branchId,
		cards,
		validDate,
		expireDate,
	});
};
export default {
	list,
	listSold,
	listByGroup,
	find,
	detail,
	download,
	generate,
	allowDepositStatus,
	switchAllowDepositStatus,
	transactions,
	modifySalesPrice,
	refund,
	resend,
	downloadTransactions,
	downloadGiftCards,
	downloadSettleList,
	batchActivate,
	batchActivateByCodes,
};
